import { http } from 'connex-cds';

export default {
  listDriverTickets: ({ entityRef, queryParams }) => {
    return http.get({
      apiName: 'mt',
      path: `/${entityRef}/list-driver-tickets`,
      queryParams,
    });
  },
};
